import { render, staticRenderFns } from "./WorkOrderInventoryCard.vue?vue&type=template&id=34490c1f&scoped=true"
import script from "./WorkOrderInventoryCard.vue?vue&type=script&lang=js"
export * from "./WorkOrderInventoryCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34490c1f",
  null
  
)

export default component.exports